import req from "@/utils/axios.js";

// 传 code 到后端，获取用户信息
export function getWeComUserInfo(code) {
    return req.post("/wxShop/auth", {
        state: 'STATE123',
        code: code,
    });
}
